var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { UserPreferences } from '../classes/user-preferences';
var UserSchema = /** @class */ (function () {
    function UserSchema(args) {
        if (args === void 0) { args = {}; }
        this.updatedByStorage = false;
        this.email = args.email;
        this.buy = args.buy;
        this.language = args.language;
        // The server sends back a name initially with just a space in it, thus giving it problems
        this.name = args.name ? args.name.trim() : '';
        this.phoneNumber = args.phoneNumber;
        this.sell = args.sell;
        this.city = args.city;
        this.province = args.province;
        this.marketingEmails = args.marketingEmails;
        this.preferences = args.preferences ? args.preferences : new UserPreferences();
        this.maxPerxPreferences = args.maxPerxPreferences;
    }
    return UserSchema;
}());
export { UserSchema };
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /* Methods go here. */
    User.prototype.getInitials = function () {
        if (!this.name)
            return null;
        var values = this.name.split(' ');
        if (values.length >= 2) {
            return values[0].charAt(0).toUpperCase() + values[1].charAt(0).toUpperCase();
        }
        else {
            return values[0].charAt(0).toUpperCase();
        }
    };
    return User;
}(UserSchema));
export { User };
